import { Injectable } from '@angular/core';
import { Router, Resolve, RouterStateSnapshot, ActivatedRouteSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { Dossier } from './dossier';
import { DossierService } from './dossier.service';
import { lookupParam } from '../nav/utils';

@Injectable()
export class DossierResolver implements Resolve<Dossier> {

  constructor(
    private router: Router,
    private dossierService: DossierService
  ) {
  }

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Dossier | Observable<Dossier> | Promise<Dossier> {
    return new Promise<Dossier>(async (resolve, reject) => {

      let dossier_id = lookupParam(route, 'dossier_id');

      this.dossierService
        .dossier(dossier_id)
        .subscribe((dossier) => {
          
          if(dossier) {
            return resolve(dossier);
          }
          else {
            this.router.navigate(['dossiers']);
            return resolve(null);
          }
        });
    });
  }
}